import React from 'react'
import { IconProps } from '../../../common/types'

const TimerIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.83412C7.724 4.83412 7.5 5.05812 7.5 5.33412V8.00012C7.5 8.13212 7.552 8.26012 7.646 8.35412L9.312 10.0201C9.41 10.1181 9.538 10.1661 9.666 10.1661C9.794 10.1661 9.922 10.1181 10.02 10.0201C10.216 9.82412 10.216 9.50812 10.02 9.31212L8.5 7.79212V5.33212C8.5 5.05812 8.276 4.83412 8 4.83412ZM10.75 12.7641C9.942 13.2321 9.002 13.5001 8 13.5001C4.962 13.5001 2.5 11.0381 2.5 8.00012C2.5 7.72412 2.276 7.50012 2 7.50012C1.724 7.50012 1.5 7.72412 1.5 8.00012C1.5 11.5901 4.41 14.5001 8 14.5001C9.184 14.5001 10.294 14.1841 11.25 13.6301C11.49 13.4921 11.57 13.1861 11.432 12.9461C11.294 12.7081 10.988 12.6261 10.75 12.7641ZM8 1.50012C7.994 1.50012 7.986 1.50012 7.98 1.50012C6.316 1.49012 4.652 2.11412 3.386 3.38012L3.384 2.88212C3.382 2.60612 3.158 2.38412 2.882 2.38412C2.606 2.38612 2.384 2.61012 2.384 2.88612L2.392 4.58412C2.394 4.85812 2.616 5.08012 2.89 5.08212L4.588 5.09012C4.864 5.09212 5.09 4.86812 5.09 4.59212C5.092 4.31612 4.868 4.09012 4.592 4.09012L4.136 4.08812C5.124 3.11212 6.48 2.50812 7.978 2.50212C9.382 2.51212 10.79 3.05612 11.868 4.13412L11.89 4.11212C12.884 5.10612 13.5 6.48212 13.5 8.00012C13.5 9.00212 13.232 9.94212 12.764 10.7501C12.626 10.9881 12.708 11.2941 12.946 11.4341C13.186 11.5721 13.49 11.4901 13.63 11.2521C14.184 10.2941 14.5 9.18412 14.5 8.00012C14.5 4.41012 11.59 1.50012 8 1.50012Z"
        fill="#65328D"
      />
    </svg>
  )
}

export default TimerIcon
